// extracted by mini-css-extract-plugin
export default {"noteContainer":"Notes_noteContainer__vJW+I","label":"Notes_label__hp11r","message":"Notes_message__U6K0E"};